import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICommitHistoryInput, ICommitHistoryRes } from '../../../../interface/interfaces';

interface IInitialState {
    commitHistoryLoading: boolean;
    commitHistoryData: ICommitHistoryRes[];
    commitHistoryError: string;
}

const initialState: IInitialState = {
    commitHistoryLoading: false,
    commitHistoryData: [],
    commitHistoryError: '',
};

const commitHistorySlice = createSlice({
    name: 'commitHistory',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchCommitHistoryPending: (state: IInitialState, action: PayloadAction<ICommitHistoryInput>) => {
            state.commitHistoryLoading = true;
            state.commitHistoryError = '';
        },
        fetchCommitHistoryFulfilled: (state: IInitialState, action: PayloadAction<ICommitHistoryRes[]>) => {
            state.commitHistoryLoading = false;
            state.commitHistoryData = action.payload;
            state.commitHistoryError = '';
        },
        fetchCommitHistoryFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.commitHistoryLoading = false;
            state.commitHistoryData = [];
            state.commitHistoryError = action.payload;
        },
    },
});

export default commitHistorySlice.reducer;
export const { fetchCommitHistoryPending, fetchCommitHistoryFulfilled, fetchCommitHistoryFailure } = commitHistorySlice.actions;
